module.exports = __webpack_public_path__ + "img/10.c5d27683.svg";